// Creates a previous/next navigation item with an icon or fallback arrow symbol
const createNavItem = (label, iconSrc, onClick, disabled) => {
    const li = document.createElement('li')
    li.className = `page-item${disabled ? ' disabled' : ''}`

    const a = document.createElement('a')
    a.className = 'page-link'
    a.href = '#'
    a.setAttribute('aria-label', label)

    if (iconSrc) {
        const img = document.createElement('img')
        img.src = iconSrc
        img.setAttribute('aria-hidden', 'true')
        a.appendChild(img)
    } else {
        const span = document.createElement('span')
        span.setAttribute('aria-hidden', 'true')
        span.innerHTML = label === 'Previous' ? '&laquo;' : '&raquo;'
        a.appendChild(span)
    }

    a.addEventListener('click', (e) => {
        e.preventDefault()
        if (!disabled) onClick()
    })

    li.appendChild(a)
    return li
}

// Creates a numbered page button; active page is non-clickable
const createPageItem = (page, active, onClick) => {
    const li = document.createElement('li')
    li.className = `page-item${active ? ' active' : ''}`

    const a = document.createElement('a')
    a.className = 'page-link'
    a.href = '#'
    a.textContent = page

    a.addEventListener('click', (e) => {
        e.preventDefault()
        if (!active) onClick()
    })

    li.appendChild(a)
    return li
}

// Initialises pagination for a single participants container
const initSingleParticipants = (container) => {
    const pageSize = parseInt(container.dataset.pageSize, 10) || 20
    const rowsContainer = container.querySelector('[data-participants-rows]')
    const pagination = container.querySelector('[data-participants-pagination]')

    if (!rowsContainer || !pagination) return

    // Icon paths for prev/next in active and disabled states, set via data attributes
    const { iconPrev = '', iconPrevDisabled = '', iconNext = '', iconNextDisabled = '' } = container.dataset
    const rows = Array.from(rowsContainer.children)
    const totalPages = Math.ceil(rows.length / pageSize)
    let currentPage = 1

    // Rebuilds the pagination UI; onPageChange is called with the target page number
    const renderPagination = (onPageChange) => {
        pagination.innerHTML = ''
        if (totalPages <= 1) return

        const ul = document.createElement('ul')
        ul.className = 'pagination'

        const prevDisabled = currentPage === 1
        ul.appendChild(createNavItem(
            'Previous',
            prevDisabled ? iconPrevDisabled : iconPrev,
            () => onPageChange(currentPage - 1),
            prevDisabled,
        ))

        for (let i = 1; i <= totalPages; i++) {
            ul.appendChild(createPageItem(i, i === currentPage, () => onPageChange(i)))
        }

        const nextDisabled = currentPage === totalPages
        ul.appendChild(createNavItem(
            'Next',
            nextDisabled ? iconNextDisabled : iconNext,
            () => onPageChange(currentPage + 1),
            nextDisabled,
        ))

        pagination.appendChild(ul)
    }

    // Shows the given page: hides out-of-range rows, re-renders pagination and scrolls to the list top
    const showPage = (page, scroll = false) => {
        currentPage = page
        const start = (page - 1) * pageSize
        const end = start + pageSize

        rows.forEach((row, i) => {
            row.hidden = i < start || i >= end
        })

        renderPagination((p) => showPage(p, true))

        if (scroll) {
            const top = container.getBoundingClientRect().top + window.scrollY - 30
            window.scrollTo({ top, behavior: 'smooth' })
        }
    }

    showPage(1)
}

// Finds all [data-participants] containers on the page and initialises each one
export const initParticipants = () => {
    document.querySelectorAll('[data-participants]').forEach(initSingleParticipants)
}
